import { Button, Label, Modal, ModalBody, ModalHeader, TextInput } from "flowbite-react";
import type { FC } from "react";
import { useState, useEffect } from "react";
import { HiPencilAlt } from "react-icons/hi";
import type { CommissionLevel } from "../../../types/commission-level";
import { updateCommissionLevel } from "../../../services/commission-levels";

interface EditCommissionLevelModalProps {
  level: CommissionLevel;
  onUpdate: () => Promise<void>;
}

export const EditCommissionLevelModal: FC<EditCommissionLevelModalProps> = function ({
  level,
  onUpdate,
}) {
  const [isOpen, setOpen] = useState(false);
  const [levelNumber, setLevelNumber] = useState<number>(level.level_number);
  const [description, setDescription] = useState(level.description);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    setLevelNumber(level.level_number);
    setDescription(level.description);
  }, [level]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setIsProcessing(true);
      await updateCommissionLevel(level.id, {
        level_number: levelNumber,
        description,
      });
      await onUpdate();
      setOpen(false);
    } catch (error) {
      console.error("Failed to update commission level:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <>
      <Button color="primary" size="sm" onClick={() => setOpen(true)}>
        <HiPencilAlt className="mr-2 text-lg" />
        Bearbeiten
      </Button>
      <Modal onClose={() => setOpen(false)} show={isOpen}>
        <ModalHeader className="border-b border-gray-200 !p-6 dark:border-gray-700">
          <strong>Provisions-Level bearbeiten</strong>
        </ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <Label htmlFor="levelNumber">Level Nummer</Label>
                <TextInput
                  id="levelNumber"
                  name="levelNumber"
                  type="number"
                  value={levelNumber}
                  onChange={(e) => setLevelNumber(parseInt(e.target.value))}
                  required
                />
              </div>
              <div>
                <Label htmlFor="description">Beschreibung</Label>
                <TextInput
                  id="description"
                  name="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="mt-6 flex items-center gap-x-3">
              <Button color="primary" type="submit" disabled={isProcessing}>
                Speichern
              </Button>
              <Button color="gray" onClick={() => setOpen(false)}>
                Abbrechen
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};
